import React from 'react'

// Styles
import * as styles from './style'
// Helpers
import ImageUtils from '../../../utils/img.utils'
import { internalLinkHandler } from '../../../utils/link.utils'
// Components
import Button from '../button'
const FeaturedTiles = (props: any) => {
  if (!props.data) return null
  const { tile1, tile2, tile3 } = props.data
  let tile1Bg = ImageUtils.getResizedImageUrl(tile1?.media?.image?.file?.url, '')
  let tile2Bg = ImageUtils.getResizedImageUrl(tile2?.media?.image?.file?.url, '')
  let tile3Bg = ImageUtils.getResizedImageUrl(tile3?.media?.image?.file?.url, '')

  const clickTileCta = (e: any, tile: any) => {
    e.preventDefault()
    window.location.href = tile?.cta?.internalLink
      ? internalLinkHandler(tile?.cta?.internalLink)
      : tile?.cta?.externalUrl
  }

  return (
    <styles.Tiles
      $tile1theme={tile1?.theme}
      $tile2theme={tile2?.theme}
      $tile3theme={tile3?.theme}
      $tile1Bg={tile1Bg}
      $tile2Bg={tile2Bg}
      $tile3Bg={tile3Bg}>
      <section className="new__area">
        <div className="panelContainer">
          <div className="leftPanel">
            <div className={`item__box primary ${tile1?.theme}`}>
              <a
                href={
                  tile1?.cta?.internalLink
                    ? internalLinkHandler(tile1?.cta?.internalLink)
                    : tile1?.cta?.externalUrl || '#'
                }>
                <div className={`item__bg primary1 ${tile1?.theme}`} data-cy="tile-primary1"></div>
                <div className="contentPart">
                  <h2 className="mb-25">{tile1?.title}</h2>
                  {tile1?.description && <p>{tile1?.description}</p>}
                  <Button
                    text={tile1?.cta?.text}
                    type="secondary"
                    icon={true}
                    theme={tile1?.theme}
                    href={
                      tile1?.cta?.internalLink
                        ? internalLinkHandler(tile1?.cta?.internalLink)
                        : tile1?.cta?.externalUrl
                    }
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="rightPanel">
            <div className={`item__box secondary ${tile2?.theme}`}>
              <a
                href={
                  tile2?.cta?.internalLink
                    ? internalLinkHandler(tile2?.cta?.internalLink)
                    : tile2?.cta?.externalUrl || '#'
                }>
                <div
                  className={`item__bg secondary1 ${tile2?.theme}`}
                  data-cy="tile-secondary1"></div>
                <div className="contentPart">
                  <h2 className="mb-25">{tile2?.title}</h2>
                  <Button
                    text={tile2?.cta?.text}
                    type="secondary"
                    icon={true}
                    theme={tile2?.theme}
                    href={
                      tile2?.cta?.internalLink
                        ? internalLinkHandler(tile2?.cta?.internalLink)
                        : tile2?.cta?.externalUrl
                    }
                  />
                </div>
              </a>
            </div>

            <div className={`item__box secondary ${tile3?.theme}`}>
              <a
                href={
                  tile3?.cta?.internalLink
                    ? internalLinkHandler(tile3?.cta?.internalLink)
                    : tile3?.cta?.externalUrl || '#'
                }>
                <div
                  className={`item__bg secondary2 ${tile3?.theme}`}
                  data-cy="tile-secondary2"></div>
                <div className="contentPart">
                  <h2 className="mb-25">{tile3?.title}</h2>
                  <Button
                    text={tile3?.cta?.text}
                    type="secondary"
                    icon={true}
                    theme={tile3?.theme}
                    href={
                      tile3?.cta?.internalLink
                        ? internalLinkHandler(tile3?.cta?.internalLink)
                        : tile3?.cta?.externalUrl
                    }
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </styles.Tiles>
  )
}

export default FeaturedTiles
